define('invite-popover/invite-popover',['require','lib/check-first-visit','lib/multivariate-testing/multivariate-testing','text!./invite-popover.html'],function (require) {
    var checkFirstVisit = require('lib/check-first-visit');
    var self = this;
    var wasShown = false;
    var multivariateTesting = require('lib/multivariate-testing/multivariate-testing');

    self.hidePopover = function () { $('#invite-people').popover('hide') };

    function show() {
        $.when(
            multivariateTesting.checkVariation('g2mmSchedulingTest'),
            checkFirstVisit.check()
        ).then(function (variation, isFirstLogin) {
            var isG2MMSchedulingTest = variation === 'variation-a';
            var inviteButton = $('#invite-people');

            if (isG2MMSchedulingTest && isFirstLogin && !wasShown) {
                wasShown = true;
                inviteButton.popover({
                    trigger: 'manual',
                    placement: 'bottom',
                    html: true,
                    template: require('text!./invite-popover.html'),
                    content: function () { return $('#invite-popover-content').html() }
                });

                inviteButton.popover('show');

                inviteButton.click(function () {
                    self.hidePopover();
                });

                $('#invite-popover-close-btn').click(function (event) {
                    self.hidePopover();
                    event.stopPropagation();
                });
            }
        });
    }
    return {
        show: show
    };
});

